import { render } from "./CustomValidationRules.vue?vue&type=template&id=7a9ba9b8"
import script from "./CustomValidationRules.vue?vue&type=script&lang=js"
export * from "./CustomValidationRules.vue?vue&type=script&lang=js"
script.render = render

export default script